<template>
    <div>
        <EditMedicine />
    </div>
</template>

<script>
import EditMedicine from '@/components/medicine/EditMedicine.vue';
export default {
    components: {
        EditMedicine
    },
    name: 'MedicineEdit'
}
</script>